import React from 'react';
import { motion } from 'framer-motion';
import { Container } from './ui/Container';
import { SectionTag } from './ui/SectionTag';
import { CTAButton } from './ui/CTAButton';
import { CheckItem } from './ui/CheckItem';
import { GuaranteeLine } from './ui/GuaranteeLine';
import { FULL_MOCKUP_URL } from '../data/images';
import { valueStackItems } from '../data/sections';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
export function ValueStack() {
  return <section className="bg-mp-dark py-20 md:py-28" data-id="element-459" data-mp="2myca3addji41">
      <Container data-id="element-460" data-mp="2mxu5nqgk5xl1">
        <div className="flex flex-col items-center gap-12 md:flex-row md:items-center md:gap-16" data-id="element-461" data-mp="2n0gcfnvmk927">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5,
          ease: easeOut
        }} className="w-full md:w-[45%]" data-id="element-462" data-mp="295e9n9m2qztm">
            <div className="relative" data-id="element-463" data-mp="35qeijyfv3s37">
              <div className="pointer-events-none absolute inset-0 -z-10 rounded-full opacity-60 blur-2xl" style={{
              background: 'radial-gradient(circle, rgba(216,240,0,0.18), transparent 70%)'
            }} aria-hidden="true" data-id="element-464" data-mp="1tf3fs053ih2m" />
              <img src={FULL_MOCKUP_URL} alt="Todo lo que incluye Maestro en Pista" width={700} height={700} loading="lazy" className="mx-auto w-full max-w-[480px]" data-id="element-465" data-mp="236zhrmaayrc4" />
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5,
          ease: easeOut,
          delay: 0.05
        }} className="w-full md:w-[55%]" data-id="element-466" data-mp="2m3sa9gbnbo5e">
            <SectionTag tone="lime" data-id="element-467" data-mp="mqwll9jpocbp">Esto es lo que desbloqueas hoy</SectionTag>
            <h2 className="mt-5 font-heading text-3xl uppercase leading-tight text-mp-white sm:text-4xl" data-id="element-468" data-mp="mt0zmkbbqrpp">
              Tu nuevo sistema de trabajo en pista.
            </h2>

            <ul className="mt-7 space-y-3" data-id="element-469" data-mp="2rsshrw4gd5fl">
              {valueStackItems.map(item => <CheckItem key={item} data-id="element-470" data-mp="2vt2kmzwy7fq8">{item}</CheckItem>)}
            </ul>

            <p className="mt-6 font-heading text-xs uppercase tracking-[0.18em] text-mp-electric" data-id="element-471" data-mp="30u07hpswkxy2">
              5 Tomos + 5 Bonos
            </p>

            <div className="mt-6 rounded-2xl border border-mp-border bg-mp-card p-6" data-id="element-472" data-mp="35q79x8m3brb9">
              <p className="font-heading text-sm uppercase tracking-wide text-mp-white" data-id="element-473" data-mp="3ap0eucnba9zt">
                Descubre los dos planes disponibles
              </p>
              <p className="mt-1 text-sm text-mp-gray" data-id="element-474" data-mp="3jidhi6b6gpz3">Base o Kit de Ejecución completo — tú eliges.</p>

              <CTAButton href="#oferta" className="mt-5 w-full" showArrow data-id="element-475" data-mp="3ojufnu2a1ybz">
                Ver las ofertas
              </CTAButton>

              <GuaranteeLine className="mt-4" data-id="element-476" data-mp="3tfi7kh8595l6" />
            </div>
          </motion.div>
        </div>
      </Container>
    </section>;
}